import { Dispatcher, DispatcherUnsubscribe, dipspatcherPreventDefault } from "../../dispatcher"
import { toProxy } from "../../watcher"

const dispatcher = new Dispatcher()
interface IHistory{
    state:any
    title:string
    url:string
    isReplace:boolean
    changeState:string
}
let browserHistoryList:IHistory[] = [];
;
function initBrowserHistoryListener(){
    if(typeof window === 'undefined')return
    browserHistoryList = toProxy([])
    const onChangeState = (state:any, title:string, url:string, changeState:string, isReplace:boolean) => { 
        // define your listener here ...
        browserHistoryList.push({state, title, url, changeState, isReplace})
        // console.log('bbbbbbbbbbbbbbb**************', 'state=', state, 'title=', title, 'url=', url, 'changeState=', changeState, 'isReplace=', isReplace, 'browserHistoryList=', browserHistoryList)
    }
    
    // set onChangeState() listener:
    ['pushState', 'replaceState'].forEach((changeState) => {
    //    ( window.history as any )['_' + changeState] = (window.history as any)[changeState]
        
        (window.history as any)[changeState] = new Proxy((window.history as any)[changeState], {
            apply (target, thisArg, argList) {
                // console.log('history called----', 'target=', target, 'thisArg=', thisArg, 'argList=', argList)
                const [state, title, url] = argList
                const event = AskHistoryBackEvent.create(
                    {state, title, url, changeState, isReplace:changeState === 'replaceState'}
                )
                const res = dispatcher.dispatch(AskHistoryBackEvent.HISTORY_BACK, event)
                if(res === dipspatcherPreventDefault || event.defaultPrevented){
                    return
                }
                onChangeState(state, title, url, changeState, changeState === 'replaceState')
                
                return target.apply(thisArg, argList)
            },
        })
    })
    window.addEventListener('popstate', (e)=>{
        // console.log("window.addEventListener('popstate'", e)
        browserHistoryList.pop()
        const event = AskHistoryBackEvent.create()
        const res = dispatcher.dispatch(AskHistoryBackEvent.HISTORY_BACK, event)
        // console.log('popstate res', res, event)
    })
}

export class AskHistoryBackEvent {
    static readonly HISTORY_BACK = 'HistoryBack'
    data?:IHistory
    private _defaultPrevented:boolean = false
    get defaultPrevented(){
        return this._defaultPrevented
    }
    constructor(data?:IHistory){
        this.data = data
    }
    preventDefault(){
        this._defaultPrevented = true
    }
    static create(data?:IHistory){
        return new AskHistoryBackEvent(data)
    }
}


interface IBrowserHistoryUtils{
    readonly browserHistoryList:IHistory[]
    initBrowserHistoryListener:()=>void
    listenAskHistoryBack(handler:(event:AskHistoryBackEvent)=>void):DispatcherUnsubscribe
    urlIsInLastHistory:(url:string)=>boolean
    /**
     * 如果url已经在lastHistory中，则不pushState
     * @param state 
     * @param title 
     * @param url 
     * @param options canDuplicate: 如果url已经在lastHistory中，则不pushState
     * @param options lastCanDuplicate: 如果url已经在lastHistory中，则不pushState
     * @returns 
     */
    pushState:(state:any, title:string, url:string, options?:IBrowserPushStateOptions)=>void
    askHistoryBack:(data?:IHistory)=>AskHistoryBackEvent
}

export const browserHistoryUtils:IBrowserHistoryUtils = {
    browserHistoryList,
    initBrowserHistoryListener,
    listenAskHistoryBack: (handler:(event:AskHistoryBackEvent)=>void):DispatcherUnsubscribe=>{
        return dispatcher.addListener(AskHistoryBackEvent.HISTORY_BACK, handler)
    },
    urlIsInLastHistory:(url:string)=>{
        return browserHistoryList.length > 0 && browserHistoryList[browserHistoryList.length - 1].url === url
    },
    pushState:(state:any, title:string, url:string, options:IBrowserPushStateOptions = {})=>{
    options.canDuplicate = options.canDuplicate === undefined ? false : options.canDuplicate
    options.lastCanDuplicate = options.lastCanDuplicate === undefined ? false : options.lastCanDuplicate

    if(!options.lastCanDuplicate && (browserHistoryUtils.urlIsInLastHistory(url))) return
    window.history.pushState(state, title, url)
    },
    askHistoryBack:(data?:IHistory)=>{
        const event = AskHistoryBackEvent.create(data)
        dispatcher.dispatch(AskHistoryBackEvent.HISTORY_BACK, event)
        return event
    }
}

export interface IBrowserPushStateOptions{
    canDuplicate?:boolean
    lastCanDuplicate?:boolean
}
